import { JackpotDisplayType, Settings } from "./Settings";
import { JackpotLevel } from "./api";

export type JackpotProperties = Record<JackpotLevel, JackpotPropertiesLevel>;

export interface JackpotPropertiesLevel {
    name: string;
    color: string;
}

export const JackpotShowtimeDuration: Readonly<Record<JackpotLevel, number>> = {
    [JackpotLevel.Jp5]: null,
    [JackpotLevel.Jp5s]: null,
    [JackpotLevel.Jp4]: 42000,
    [JackpotLevel.Jp4s]: 42000,
    [JackpotLevel.Jp3]: 29000,
    [JackpotLevel.Jp3s]: 29000,
    [JackpotLevel.Jp2]: 23000,
    [JackpotLevel.Jp1]: 10000,
}

export const JackpotProperties: Readonly<Record<JackpotDisplayType, Readonly<JackpotProperties>>> = {
    [JackpotDisplayType.PreciousSpin]: null,
    [JackpotDisplayType.DiamondPot]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotOrtiz]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotStep]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DragonJackpot]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DRAGON", color: "YELLOW" },
        [JackpotLevel.Jp4s]: { name: "DRAGON shared", color: "YELLOW" },
        [JackpotLevel.Jp3]: { name: "GRAND", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "GRAND shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "#05DBF2" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "#50F205" },
    },
    [JackpotDisplayType.DiamondPotJubilee]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotCaliente]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotPlayCity]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.JubileeLink]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.ViventoLink]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.RapidDiamondPot]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.RapidDiamondPot2]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.RapidDiamondPotStep]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.PaytableJackpotDisplay]: null,
    [JackpotDisplayType.RapidDiamondPotFire]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.PlayCityLink]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.DiamondPotRappidFrames]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.RapidDiamondPotStep2]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },

    [JackpotDisplayType.RainbowGirls]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "MEGA", color: "#FF00FF" },
        [JackpotLevel.Jp4s]: { name: "MEGA shared", color: "#FF00FF" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "#FF0000" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "#FF0000" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "#00FF00" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "#0000FF" },
    },

    [JackpotDisplayType.DiamondPotStepRappidFrames]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },

    [JackpotDisplayType.DiamondPotStepShared]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSharedSpineV2]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSinShared]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotRappidFramesSpine]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidShared]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidShared2S]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.PlayCityLinkResponsive]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JubileeLinkResponsive]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotResponsive]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" }
    },
    [JackpotDisplayType.PlayCityLinkResponsivePIXI]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXI]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotResponsivePIXI]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: undefined, //{ name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: undefined, //{ name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05447a" /*color: "#05DBF2"*/ }
    },
    [JackpotDisplayType.DiamondPotPyramidSinShared2S]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.DiamondPotPyramidSinSharedResponsive]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp4s]: { name: "RUBY shared", color: "#F2294E" },
        [JackpotLevel.Jp3]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp3s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "white" },
        [JackpotLevel.Jp3s]: { name: "RUBY shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMERALD", color: "white" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "white" },
    },
    [JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "DIAMOND", color: "white" },
        [JackpotLevel.Jp4s]: { name: undefined, color: undefined }, // { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp3]: { name: "RUBY", color: "#F2294E" },
        [JackpotLevel.Jp3s]: { name: undefined, color: undefined }, // { name: "DIAMOND shared", color: "white" },
        [JackpotLevel.Jp2]: { name: "EMMERALD", color: "#50F205" },
        [JackpotLevel.Jp1]: { name: "SAPPHIRE", color: "#05DBF2" },
    },
    [JackpotDisplayType.MysticPortalLink3S]: {
        [JackpotLevel.Jp5]: { name: "MEGA", color: "red" },
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "purple" },
        [JackpotLevel.Jp4s]: null,
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "orange" },
        [JackpotLevel.Jp3s]: null,
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: {
        [JackpotLevel.Jp5]: null,
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "red" },
        [JackpotLevel.Jp4s]: { name: "GRAND shared", color: "red" },
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "purple" },
        [JackpotLevel.Jp3s]: { name: "MAJOR shared", color: "purple" },
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.MysticPortalLinkHorizontal]: {
        [JackpotLevel.Jp5]: { name: "MEGA", color: "red" },
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "purple" },
        [JackpotLevel.Jp4s]: null,
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "orange" },
        [JackpotLevel.Jp3s]: null,
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    },
    [JackpotDisplayType.MysticPortalResponsive]: {
        [JackpotLevel.Jp5]: { name: "MEGA", color: "red" },
        [JackpotLevel.Jp5s]: null,
        [JackpotLevel.Jp4]: { name: "GRAND", color: "purple" },
        [JackpotLevel.Jp4s]: null,
        [JackpotLevel.Jp3]: { name: "MAJOR", color: "orange" },
        [JackpotLevel.Jp3s]: null,
        [JackpotLevel.Jp2]: { name: "MINOR", color: "green" },
        [JackpotLevel.Jp1]: { name: "MINI", color: "blue" },
    }
}
